export default __webpack_public_path__ + "static/media/google-ads.02808b71.svg";